<template>

  <div>

    <div class="filters-frame" v-if="count > 1 && !sample">
      <a class="button mod-filter" v-for="c in categories" @click.prevent="setActive(c.cat_ID)" :class="{ active : catID === c.cat_ID }" href="#">{{c.name}}</a>
    </div>

    <div class="blog-posts-frame">

      <article class="blog-post" v-for="d in display" :key="d.id">
        <a v-if="d.acf.header_image" :href="d.link" class="blog-post-img" :style="{ backgroundImage: 'url(' + d.acf.header_image.sizes.medium_large + ')' }"></a>
        <a v-else :href="d.link" class="blog-post-img" :style="{ backgroundImage: 'url(' + d.thumb + ')' }"></a>
        <div class="blog-post-excerpt">
          <div>
            <a :href="d.link"><h4>{{d.post_title}}</h4></a>
            <p>{{d.acf.excerpt}}</p>
            <div class="blog-post-excerpt-sub">{{d.author}} |</div>
            <div class="blog-post-excerpt-sub">{{niceDate(d.post_date)}}</div>
            <div class="blog-post-excerpt-sub mod-category">
              <span v-for="c in d.categories" v-if="c.term_id != 1">{{c.name}}</span>
            </div>
          </div>
          <a :href="d.link" class="button mod-readmore">Read More</a>
        </div>
      </article>

      <div class="loader" :class="{ loading: loading }">
        <div class="spinner">
          <div class="double-bounce1"></div>
          <div class="double-bounce2"></div>
        </div>
      </div>

    </div>

    <div class="page-action" v-if="isMore && !sample" :class="{ hidden: loading }">
      <a class="button mod-load-more active" @click.prevent="loadMore()" href="#" rel="nofollow">Load a few more</a>
    </div>

  </div>

</template>



<script type="text/babel">

  import moment from 'moment';
  import _ from 'lodash';

  export default {

    data() {
      return {
        catID: 1,
        start: 0,
        end: this.count,
        loading: false,
      }
    },

    mounted() {
      this.loading = true;
      this.setActive(this.catID)
    },

    props: {
      posts: {
        type: Array,
        default: []
      },
      count: {
        type: Number,
        default: 20
      },
      sample: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      store: function() {
        var vm = this, store = [];

        for(let post of vm.posts){
          for(let cat of post.categories){
            if (cat.cat_ID == vm.catID){
              store.push(post);
              break;
            }
          }
        }

        setTimeout(() => { this.loading = false; }, 1000);

        return store;
      },

      categories: function(){
        var vm = this, c = [];

        for(let post of vm.posts){
          for(let cat of post.categories){
            c.push(cat)
          }
        }

        return _.uniqBy(c, 'cat_ID');
      },

      display: function(){
        return this.store.slice(this.start,this.end);
      },

      isMore: function(){
        if ((this.count > 1) && (this.store.length > this.display.length)) {
          return true
        }
      }
    },

    methods: {
      niceDate: function(iso){
        return moment(iso, 'YYYY-MM-DDT HH:mm:ss').format('MMMM DD, YYYY');
      },

      setActive(id){
        this.loading = true;
        this.end = this.count;

        setTimeout(() => {
          this.catID = id;
        }, 500);

        setTimeout(() => {
          this.loading = false;
        }, 800);

      },

      loadMore(){
        this.loading = true;

        setTimeout(() => {
          this.end += this.count;
          this.loading = false;
        }, 800);
      },
    },
  }

</script>